// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__swcHv","detailsBorder":"styles_detailsBorder__3cjh-"};